export default "__VITE_ASSET__ab478cd2__"